import Cookies from "js-cookie";

const BASE_URL = "https://orchestration.trackdsa.in";

export const getValidToken = async () => {
  const accessToken = Cookies.get("accessToken");
  const refreshToken = Cookies.get("refreshToken");

  if (!accessToken || !refreshToken) throw new Error("No tokens found. Please login.");

  const res = await fetch(`${BASE_URL}/user/verifyaccess`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ accessToken, refreshToken }),
  });

  const data = await res.json();
  if (data.accessToken === false) throw new Error("Session expired");

  Cookies.set("accessToken", data.accessToken, { expires: 7 });
  return { token: data.accessToken, userid: data.userid };
};

export const apiClient = async (endpoint, options = {}) => {
  const { userid } = await getValidToken();
  
  // Auto-inject userid for mutations
  let body = options.body ? JSON.parse(options.body) : {};
  if (options.method && options.method !== "GET") {
    body.userid = userid;
    options.body = JSON.stringify(body);
  }

  const res = await fetch(`${BASE_URL}${endpoint}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

  if (!res.ok) throw new Error(await res.text());
  return res.json();
};